import { ref } from 'vue'

export const token = ref<string | null>(null)
